var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-autocomplete",
    _vm._b(
      {
        attrs: {
          "search-input": _vm.input,
          label: _vm.label,
          "no-data-text": !_vm.input
            ? "Enter " + _vm.label + " name"
            : "No " + _vm.label + " found",
          "hide-selected": "",
        },
        on: {
          "update:searchInput": function ($event) {
            _vm.input = $event
          },
          "update:search-input": function ($event) {
            _vm.input = $event
          },
        },
        scopedSlots: _vm._u(
          [
            _vm.input
              ? {
                  key: "no-data",
                  fn: function () {
                    return [
                      !_vm.hideCreate
                        ? _c(
                            "v-list-item",
                            {
                              attrs: {
                                disabled: !_vm.createRules.every(function (
                                  rule
                                ) {
                                  return rule(_vm.input)
                                }),
                                "two-line": "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("create", _vm.input)
                                },
                              },
                            },
                            [
                              _c(
                                "v-list-item-content",
                                [
                                  _c("v-list-item-title", [
                                    _vm._v(
                                      " Create " +
                                        _vm._s(
                                          (_vm.label || "").toLowerCase()
                                        ) +
                                        " "
                                    ),
                                    _c("strong", [_vm._v(_vm._s(_vm.input))]),
                                  ]),
                                  !_vm.createRules.every(function (rule) {
                                    return rule(_vm.input)
                                  })
                                    ? _c(
                                        "v-list-item-subtitle",
                                        {
                                          staticClass:
                                            "text-error text-caption",
                                        },
                                        [_vm._v(" Invalid ")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.hideSaveAs
                        ? _c(
                            "v-list-item",
                            {
                              attrs: {
                                "two-line": "",
                                disabled: !_vm.saveAsRules.every(function (
                                  rule
                                ) {
                                  return rule(_vm.input)
                                }),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("save-as", _vm.input)
                                },
                              },
                            },
                            [
                              _c(
                                "v-list-item-content",
                                [
                                  _c("v-list-item-title", [
                                    _vm._v(
                                      " Save " +
                                        _vm._s(
                                          (_vm.label || "").toLowerCase()
                                        ) +
                                        " as "
                                    ),
                                    _c("strong", [_vm._v(_vm._s(_vm.input))]),
                                  ]),
                                  !_vm.saveAsRules.every(function (rule) {
                                    return rule(_vm.input)
                                  })
                                    ? _c(
                                        "v-list-item-subtitle",
                                        {
                                          staticClass:
                                            "text-error text-caption",
                                        },
                                        [_vm._v(" Invalid ")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.hideRename && _vm.newValue
                        ? _c(
                            "v-list-item",
                            {
                              attrs: {
                                disabled: !_vm.renameRules.every(function (
                                  rule
                                ) {
                                  return rule(_vm.input)
                                }),
                                "two-line": "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("rename", _vm.input)
                                },
                              },
                            },
                            [
                              _c(
                                "v-list-item-content",
                                [
                                  _c("v-list-item-title", [
                                    _vm._v(
                                      " Rename " +
                                        _vm._s(
                                          (_vm.label || "").toLowerCase()
                                        ) +
                                        " as "
                                    ),
                                    _c("strong", [_vm._v(_vm._s(_vm.input))]),
                                  ]),
                                  !_vm.renameRules.every(function (rule) {
                                    return rule(_vm.input)
                                  })
                                    ? _c(
                                        "v-list-item-subtitle",
                                        {
                                          staticClass:
                                            "text-error text-caption",
                                        },
                                        [_vm._v(" Invalid ")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                }
              : null,
          ],
          null,
          true
        ),
        model: {
          value: _vm.newValue,
          callback: function ($$v) {
            _vm.newValue = $$v
          },
          expression: "newValue",
        },
      },
      "v-autocomplete",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }